// src/lib/mudoNetwork/offersApi.js
// Tiny Supabase helper for shop offers.

import { supabase } from "../../supabaseClient";

/**
 * Create a new offer (pending by default).
 * @param {object} params
 * @param {string} params.listingId
 * @param {string|null} params.studioId
 * @param {string} params.buyerId
 * @param {number} params.amount
 * @param {string|null} [params.buyerName]
 * @param {string|null} [params.buyerEmail]
 * @param {string} [params.currency="AUD"]
 * @param {string|null} [params.message]
 * @returns {{ data: any, error: any }}
 */
export async function createOffer({
  listingId,
  studioId,
  buyerId,
  amount,
  buyerName = null,
  buyerEmail = null,
  currency = "AUD",
  message = null,
}) {
  const { data, error } = await supabase
    .from("shop_offers")
    .insert({
      listing_id: listingId,
      studio_id: studioId,
      buyer_id: buyerId,
      buyer_name: buyerName,
      buyer_email: buyerEmail,
      amount,
      currency,
      message,
      status: "pending",
    })
    .select("*")
    .single();

  return { data, error };
}

/**
 * List all offers for a studio, newest first.
 */
export async function listOffersForStudio(studioId) {
  return supabase
    .from("shop_offers")
    .select("*")
    .eq("studio_id", studioId)
    .order("created_at", { ascending: false });
}

/**
 * Update the status of an offer.
 */
export async function updateOfferStatus(offerId, status) {
  const { data, error } = await supabase
    .from("shop_offers")
    .update({ status })
    .eq("id", offerId)
    .select("*")
    .single();

  return { data, error };
}
